"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERTICAL_MONTHS_SHOWN = exports.VERTICAL_MONTHS_THRESHOLD = exports.MONTH_KEYS = exports.DAY_KEYS = exports.DAYS_IN_WEEK = void 0;
exports.DAYS_IN_WEEK = 7;
exports.DAY_KEYS = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
];
exports.MONTH_KEYS = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december",
];
exports.VERTICAL_MONTHS_THRESHOLD = 2;
exports.VERTICAL_MONTHS_SHOWN = exports.VERTICAL_MONTHS_THRESHOLD * 2 + 1;
